export default {
  password: {
    changeButton: 'Changer le mot de passe',
    titleChangeDialog: 'Changer de mot de passe',
    changeDialog: {
      oldPassword: 'Ancien mot de passe',
      password: 'Nouveau mot de passe',
      confirm: 'Confirmation mot de passe',
      rules: {
        lowercase: 'Minuscule',
        uppercase: 'Majuscule',
        digit: 'Chiffre',
        caracters: 'Caractères',
        special: 'Spécial',
      },
    },
    confirmationChange: 'Mot de passe changé avec succés',
    confirmationMailSent: 'Email envoyé',
    expire: {
      title: 'Lien expiré',
      text: 'Ce lien est expiré, veuillez vous rendre dans la section mot de passe oublié pour refaire une demande de changement de mot de passe.',
    },
  },
}
